<div class="fx-layout-column fx-flex--100">
  <h1>My Account</h1>
  <div class="fx-layout-row fx-layout-column--lt-md fx-gap--16px">
    <mbnm-personal-info class="fx-flex--40"></mbnm-personal-info>
    <mbnm-coupons class="fx-flex--60"></mbnm-coupons>
  </div>
  <div class="fx-layout-row">
    <mbnm-orders class="fx-flex--100 orders"></mbnm-orders>
  </div>
</div>
